import { useEffect, useState } from "react";
import { useAuthStore } from "@/store/auth.store";
import { initEcho } from "@/lib/echo";
import { useNotificationChannel } from "@/hooks/useNotificationChannel";
import { useClassroomMessageChannels } from "@/hooks/useClassroomMessageChannels";
import { PushSubscriber } from "@/components/shared/push/PushSubscriber";

function EchoSubscriber() {
  useNotificationChannel();
  useClassroomMessageChannels();
  return null;
}

export function EchoProvider({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.token);
  const [echoReady, setEchoReady] = useState(false);

  useEffect(() => {
    if (token) {
      // Le jeton n'est plus passé : `initEcho` le relit dans le magasin à chaque demande
      // d'autorisation. Il reste la condition de montage — sans session, rien à abonner.
      initEcho();
      setEchoReady(true);
    } else {
      setEchoReady(false);
    }
  }, [token]);

  return (
    <>
      {echoReady && <EchoSubscriber />}
      {/* Séparé de `EchoSubscriber` : la sync push ne dépend pas d'Echo/Pusher, seulement d'une
          session authentifiée (le token conditionne déjà tout en interne, cf. `usePushNotifications`). */}
      {token && <PushSubscriber />}
      {children}
    </>
  );
}
